<template>
  <div class="pos-item-wrapper">
    <div class="row">
      <div class="column">
        <h4 class="name">{{record.name}}</h4>
        <div class="address">{{address}}</div>
      </div>
      <div class="logo-wrapper">
        <img v-if="record.imageUrl" :src="record.imageUrl" alt="logo" />
      </div>
    </div>
    <div class="description-wrapper">
      {{ record.description }}
    </div>
    <div class="row">
      <div class="column">
        <h5>{{$t('pos.item.cardAvability')}}</h5>
        <div class="card-types-wrapper">
          <card-type v-if="record.isic" card-type="isic" />
          <card-type v-if="record.itic" card-type="itic" />
          <card-type v-if="record.iytc" card-type="iytc" />
        </div>
      </div>
      <div class="row buttons-wrapper">
        <a v-if="record.websiteUrl" :href="record.websiteUrl" target=”_blank”
            :title="$t('pos.item.tooltip.website')" aria-label="website" class="circle-button">
          <website-icon />
        </a>
        <a v-if="record.email" :title="$t('pos.item.tooltip.email')" :href="emailLink"
            aria-label="email" class="circle-button">
          <envelope-icon />
        </a>
        <a v-if="record.phone" :title="$t('pos.item.tooltip.phone')" :href="phoneLink"
            aria-label="phone" class="circle-button">
          <phone-icon />
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .pos-item-wrapper {
    background-color: #F7F9FA;
    padding: 16px;
    border: 1px solid #EAEDEF;
    border-radius: 8px;
    margin-bottom: 16px;
  }
  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .column {
    display: flex;
    flex-direction: column;
  }
  .name {
    margin-top: 0;
    margin-bottom: 8px;
    font-size: 18px;
  }
  .logo-wrapper > img {
    max-height: 50px;
  }
  .description-wrapper {
    margin-top: 16px;
  }
  .card-types-wrapper {
    margin-top: 4px;
    display: flex;
    max-width: 40%;
  }
  h5 {
    margin-bottom: 4px;
    margin-top: 16px;
  }
  .buttons-wrapper {
    margin-top: 32px;
  }
  .circle-button {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #40b8b8;
  }
</style>

<script>
import { mapState } from 'vuex';
import CardType from './identifiers/CardType.vue';
import WebsiteIcon from './icons/WebsiteIcon.vue';
import EnvelopeIcon from './icons/EnvelopeIcon.vue';
import PhoneIcon from './icons/PhoneIcon.vue';

export default {
  name: 'pos-item',
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  components: {
    CardType,
    WebsiteIcon,
    EnvelopeIcon,
    PhoneIcon,
  },
  computed: {
    ...mapState({
      cities: (state) => state.geo.cities,
    }),
    address() {
      const city = this.cities.find((c) => c.cityGeoId === this.record.cityGeoId);
      return `${this.record.address1}, ${city.name}`;
    },
    emailLink() {
      return `mailto:${this.record.email}`;
    },
    phoneLink() {
      return `tel:${this.record.phone}`;
    },
  },
};
</script>
